var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-adm-typing-text-contianer"},[_c('input',{staticClass:"typing-text-input",attrs:{"type":"text"},domProps:{"value":_vm.keyword},on:{"input":_vm.typeText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }